function MovieIcon({ color }) {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" fill={color}>
            <path d="M19.5 4.33333L21.4717 8.27667C21.5584 8.45 21.4284 8.66667 21.2334 8.66667H19.0884C18.6767 8.66667 18.2975 8.43917 18.1242 8.07083L16.25 4.33333H14.0834L16.055 8.27667C16.1417 8.45 16.0117 8.66667 15.8167 8.66667H13.6717C13.26 8.66667 12.8809 8.43917 12.7075 8.07083L10.8334 4.33333H8.66669L10.6384 8.27667C10.725 8.45 10.595 8.66667 10.4 8.66667H8.25502C7.84335 8.66667 7.46419 8.43917 7.28002 8.07083L5.41669 4.33333H4.33335C3.14169 4.33333 2.16669 5.30833 2.16669 6.5V19.5C2.16669 20.6917 3.14169 21.6667 4.33335 21.6667H21.6667C22.8584 21.6667 23.8334 20.6917 23.8334 19.5V5.41667C23.8334 4.82083 23.3459 4.33333 22.75 4.33333H19.5Z" />
        </svg>
    );
}

export default MovieIcon;
